import { Component, computed, input } from '@angular/core';
import { NumberFormatOptions, NumberPipe } from '@progress/kendo-angular-intl';
import { CapitalizePipe, RcSelectableOverflowDirective, SupplierInvoice, ValueMismatchComponent } from 'shared';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'rc-supplier-invoice-totals',
  standalone: true,
  imports: [
    NumberPipe,
    CapitalizePipe,
    TranslateModule,
    UpperCasePipe,
    RcSelectableOverflowDirective,
    ValueMismatchComponent,
  ],
  templateUrl: './supplier-invoice-totals.component.html',
  styleUrl: './supplier-invoice-totals.component.scss',
})
export class SupplierInvoiceTotalsComponent {
  supplierInvoice = input.required<SupplierInvoice | undefined>();

  extraCosts = computed(() => {
    const si = this.supplierInvoice();
    return (si?.customFees ?? 0) + (si?.transport ?? 0);
  });

  calculatedNetTotal = computed(() => {
    const si = this.supplierInvoice();
    return (si?.netTotalItems ?? 0) + (si?.netTotalTax ?? 0) + this.extraCosts();
  });

  calculatedTaxBase = computed(() => {
    const si = this.supplierInvoice();
    const discountFactor = si?.isBelgianSupplier ? 1 - (si?.paymentDiscountPercentage ?? 0) / 100 : 1;
    const base = (si?.netTotalItems ?? 0) * discountFactor;
    return base + (si?.netTotalTax ?? 0) + this.extraCosts();
  });

  calculatedTotal = computed(() => {
    const si = this.supplierInvoice();
    return (si?.netTotal ?? 0) + (si?.vatTotal ?? 0);
  });

  calculatedPaymentDiscount = computed(() => {
    const si = this.supplierInvoice();
    return (si?.netTotalItems ?? 0) * ((si?.paymentDiscountPercentage ?? 0) / 100);
  });

  decimalFormat: NumberFormatOptions = {
    style: 'decimal',
    maximumFractionDigits: 2,
    useGrouping: true,
    minimumFractionDigits: 2,
  };
  protected readonly Math = Math;
}
